import { effects } from 'redux-saga'
import { push as pushPath } from 'react-router-redux'

export default function* authenticate() {
  const state = yield effects.select()
  const signup = state.signupEdit.get('edit')
  let returnTo;
  if (signup.id && signup.offer) {
    returnTo = `/signup/${signup.reference}#accessKey=${signup.accessKey}`;
  } else {
    returnTo = `/incoming#address=${encodeURIComponent(
      signup.address,
    )}&offer=${encodeURIComponent(signup.offer)}`
  }

  yield effects.put.resolve(
    pushPath(`/login?returnTo=${encodeURIComponent(returnTo)}`),
  )
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/authenticate.js